import clsx from 'clsx'
import { IconSvg } from 'components/common'
import { forwardRef } from 'react'

export interface CheckBoxProps {
	id?: string
	'aria-label'?: string
	checked?: boolean
	checkedLabel?: string
	uncheckedLabel?: string
	onChange?: (...args: any[]) => any
	labelPosition?: 'left' | 'right'
	disabled?: boolean
}
export const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
	({ checked, checkedLabel, uncheckedLabel, onChange, disabled, ...rest }, ref) => {
		return (
			<label className="select-none group relative block transition-all duration-300 cursor-pointer">
				<input
					ref={ref}
					id="applyUserName"
					type="checkbox"
					className="absolute left-[-9999px] peer"
					checked={checked || false}
					onChange={(...args) => {
						onChange?.(...args)
					}}
					disabled={disabled}
					{...rest}
				/>
				<div
					className={clsx('flex gap-1 items-center group', {
						'flex-row-reverse': rest.labelPosition === 'right',
					})}
				>
					<span className="text-sm transition-all duration-300">
						{checked ? checkedLabel : (uncheckedLabel ?? checkedLabel)}
					</span>
					<IconSvg
						icon="checkbox"
						className={clsx('group-peer-checked:hidden', {
							'opacity-20': disabled,
						})}
					/>
					<IconSvg
						icon="checkbox-checked"
						className={clsx('hidden group-peer-checked:block', {
							'opacity-20': disabled,
						})}
					/>
				</div>
			</label>
		)
	}
)
